import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import DateDisplay from 'src/components/DateDisplay'
import { CandidateExhibitById } from 'src/queries'

interface ListProps {
  candidate: CandidateExhibitById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { candidate } = props
  const exhibit = candidate?.exhibit
  const section1: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Sent For Review',
      value: <DateDisplay id='sentForReview' date={exhibit?.sent_for_review} />
    },
    {
      title: 'HM Approved',
      value: <DateDisplay id='hmApproval' date={exhibit?.hm_approved} />
    },
    {
      title: 'Contracts Approved',
      value: <DateDisplay id='contractsApproval' date={exhibit?.contracts_approved} />
    },
    {
      title: 'PSO Approved',
      value: <DateDisplay id='pmoApproval' date={exhibit?.pmo_approved} />
    },
    {
      title: 'Extended',
      value: <DateDisplay id='candiateExtendedOn' date={exhibit?.extended} />
    },
    {
      title: 'Signed',
      value: <DateDisplay id='candidateSignedOn' date={exhibit?.signed} />
    }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: candidate === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section1.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
